import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Divider,
  Space,
  Row,
  Col,
  Button,
  Input,
  Select,
  DatePicker,
  Radio,
} from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const CreateAfterSaleModal = ({
  isCreateAfterSaleOpen,
  setIsCreateAfterSaleOpen,
  handleAfterSaleSubmit,
  isAfterSaleLoading,
  record,
}) => {
  return (
    <Modal
      title="新增退換票設定"
      open={isCreateAfterSaleOpen}
      footer={null}
      onCancel={() => setIsCreateAfterSaleOpen(false)}
      width={600}
      destroyOnClose={true}
    >
      <Form
        name="after_sale_form"
        onFinish={handleAfterSaleSubmit}
        autoComplete="off"
        preserve={false}
        initialValues={{
          id: record?.id, // 初始化 id 值
        }}
      >
        <Divider />
        <Form.Item name="id" label="id" hidden={true}>
          {record?.id}
        </Form.Item>
        <Form.Item name="enableSwitchPolicy" label="是否開啟換票">
          <Radio.Group>
            <Radio value={true}>開啟</Radio>
            <Radio value={false}>關閉</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="switchRangeType" label="可允許換票範圍">
          <Select>
            <Select.Option value={1}>本活動範圍</Select.Option>
            <Select.Option value={2}>可跨越活動範圍</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item name="switchDateTimeRange" label="換票時間範圍">
          <DatePicker.RangePicker
            showTime={{ format: "HH:mm" }}
            format="YYYY-MM-DD HH:mm"
            className="w-full"
          />
        </Form.Item>
        <Divider />
        <Form.Item name="enableRefundPolicy" label="是否開啟退款">
          <Radio.Group>
            <Radio value={true}>開啟</Radio>
            <Radio value={false}>關閉</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="refundDateTimeRange" label="退款時間範圍">
          <DatePicker.RangePicker
            showTime={{ format: "HH:mm" }}
            format="YYYY-MM-DD HH:mm"
            className="w-full"
          />
        </Form.Item>
        <Form.Item className="text-right">
          <Button type="primary" htmlType="submit" loading={isAfterSaleLoading}>
            新增設定
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateAfterSaleModal;
